const library = {
  eyebrow: '05 — Personas',
  titleLead: 'Meet the 8',
  titleAccent: 'personas.',
  intro: 'Click a card to discover what this person needs — in workplace, collaboration and leadership.',
  introMobile: 'Click a card to discover what this person needs.',
  energyFrom: 'Energy from',
  frustrates: 'Frustrated by',
  bricksTitle: 'Bricks — Ideal workplace mix',
  leadershipTitle: 'What helps in leadership',
  // Korte werkpleklabels; de lange varianten staan in resultsCard.
  workplaceLabels: {
    focus: 'Focus',
    work: 'Standard',
    hybride: 'Hybrid',
    meeting: 'Meetings',
    project: 'Creative',
    team: 'Collaboration',
    learning: 'Learning',
    retreat: 'Retreat',
    social: 'Informal',
  },
};

export default library;
